<template>
  <v-app id="app">
    <v-navigation-drawer
      v-if="true"
      temporary
      v-model="drawer"
      app
      :disable-resize-watcher="true"
      rue
    >
      <v-list dense>
        <!--<v-list-tile :to="{name:'Extrato'}">
        <v-list-tile-action>
          <v-icon>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Extrato</v-list-tile-title>
        </v-list-tile-content>
        </v-list-tile>-->
        <v-list-tile :to="{name:'Saldo'}">
          <v-list-tile-action>
            <v-icon>contact_mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Cartão</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name:'Lojas'}">
          <v-list-tile-action>
            <v-icon>location_on</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Lojas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{name:'Logout'}">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar hidden-xs-and-down v-if="mostrarMenu" color="primary" dark fixed app>
      <v-toolbar-side-icon v-if="mostraSide" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">
        <img id="imgTopo" :src="require(`@/assets/${imgTopo}`)" alt="Sistema Pré-Pago" class="mb-5">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="pt-4">
        <v-icon size="20">person</v-icon>
        Ola,{{nome}}
      </v-toolbar-items>

      <v-tabs v-show="mostraTabs" slot="extension" centered color="primary" slider-color="terciary">
        <v-tab :to="{name:'Saldo'}">
          <v-icon size="25">credit_card</v-icon>Cartões
        </v-tab>
        <v-divider class="mx-2" vertical dark></v-divider>
        <!--<v-tab
              key="extrato"
              class="font-weight-thin"
              @click="verificaSelCartao()"
            >
              <v-icon
                size="25"
                color="white darken-2"
              >receipt</v-icon>
                Extrato
                </v-tab>
                <v-divider
                  class="mx-2"
                  vertical
                  dark
                ></v-divider>
        -->
        <v-tab v-bind:to="{name:'Lojas'}">
          <v-icon size="25">location_on</v-icon>Lojas
        </v-tab>
        <v-divider class="mx-2" vertical dark></v-divider>
        <v-tab v-bind:to="{name:'Logout'}">
          <v-icon color="yellow lighten-3">exit_to_app</v-icon>Sair
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <!--<v-footer
            color="primary"
            class="pa-2 white-text "
          >
            <v-layout>
              <v-flex
                xs12
                py-3
                text-xs-center
                white-text
              >
                www.grupotecnoweb.com.br&copy; {{ new Date().getFullYear() }}
                </v-flex>
            </v-layout>

    </v-footer>-->
  </v-app>
</template>

<script>
import EventBus from "./services/EventBus";
export default {
  name: "app",

  data: () => ({
    drawer: null,

    nome: window.sessionStorage.getItem("nome"),
    windowHeight: "",
    windowWidth: "",
    mostraSide: false,
    mostraTabs: true
    //  mostrarMenu: false
  }),
  created() {
    let currentUrl = window.location.hostname;
    let imgUrl = currentUrl.split(".");
    console.log(this.imgUrl);
    if (imgUrl[0] == "omminiprepago") {
      this.imgTopo = "logo.png";
    } else {
      this.imgTopo = imgUrl[0] + ".png";
    }
  },
  mounted() {
    this.$nextTick(() => {
      EventBus.$on("mudounome", () => {
        this.nome = window.sessionStorage.getItem("nome");
      });
    });

    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight;
      });
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  watch: {
    windowWidth() {
      if (this.windowWidth < 600) {
        this.mostraTabs = false;
        this.mostraSide = true;
      } else {
        this.mostraSide = false;
        this.mostraTabs = true;
      }
    }
  },

  computed: {
    getNome() {
      setTimeout(function() {
        return window.sessionStorage.getItem("nome");
      }, 1000);
    },
    getShow() {
      return window.sessionStorage.getItem("menu");
    },
    mostrarMenu() {
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Index" ||
        this.$route.name == "Bemvindo" ||
        this.$route.name == "Privacidade" ||
         this.$route.name == "Removerconta" ||
        this.$route.name == "ResetSenha" ||
        this.$route.name == null
      ) {
        // alert('false')
        return false;
      } else {
        // alert('true')
        return true;
      }
    }
  },
  methods: {
    verificaSelCartao() {
      if (window.sessionStorage.getItem("cartao") !== "") {
        this.$router.push("extrato");
      } else {
        alert("selecione um cartão");
      }
    }
    /*mostrarMenu() {
      console.log("antes: " + window.sessionStorage.getItem("menu"));

      setTimeout(function() {
        if (
          window.sessionStorage.getItem("menu") == "false" ||
          window.sessionStorage.getItem("menu") === false
        ) {
          this.menu = "false";
          //alert("é false");
        } else {
          //alert("é true");
          this.menu = "true";
        }
        console.log("depois: " + window.sessionStorage.getItem("menu"));
      }, 1000);
    }*/
  }
};
</script>

<style>
#imgTopo {
  margin-top: 55px;
}

body {
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 0px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495e;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: 0.02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue